import React, { useState } from "react";
import SignIn from "./SignIn";
import SignUp from "./SignUp"

const Auth = () => {

    const [index, setIndex] = useState(false)

    const toggleIndex = () => {
        setIndex((prevState) => !prevState)
    }

    return (
        <>
            {!index ? <SignIn toggleIndex={toggleIndex} index={index} /> : <SignUp toggleIndex={toggleIndex} index={index} />}
        </>
    )
}

export default Auth;